import CustomText from "../atomic/CustomText";
import CustomCheckBoxInputProps from "../../services/models/customCheckBoxInput.model";
import utils from "../../services/utils";
import CustomCheckBox from "../atomic/CustomCheckBox";

function CustomCheckBoxInput({
  labelInfo,
  name,
  checkBoxes,
  displayWhen,
  values,
  errors,
  touched,
  parentContainerClass,
  checkBoxClassName = "",
  getFieldMeta,
  manualFieldsChangeOnOptionClick,
  setFieldValue,
  setFieldTouched,
  disabled,
  checkboxesContainerClassName,
}: CustomCheckBoxInputProps): JSX.Element | null {
  const fieldName: any = name;

  const errorString = getFieldMeta?.(fieldName).error ?? "";
  const fieldTouched = getFieldMeta?.(fieldName).touched ?? "";

  const showError = errorString && fieldTouched;
  if (!!displayWhen) {
    if (!utils.displayHandler(displayWhen, values ?? {})) {
      return null;
    }
  }
  const handleManualFieldsChange = (e: any) => {
    manualFieldsChangeOnOptionClick?.(
      e.target.checked,
      setFieldValue ? setFieldValue : () => null,
      setFieldTouched ? setFieldTouched : () => null
    );
  };

  return (
    <div
      className={`${parentContainerClass} align-top  ${disabled && "cursor-not-allowed"
        }`}
    >
      {!!labelInfo.label && (
        <CustomText
          text={labelInfo.label}
          className={`inputLabel ${labelInfo.required
            ? "after:content-['*'] after:ml-1 after:text-requiredRed"
            : ""
            }`}
          fontWeight="font-semibold"
        />
      )}
      <div className={checkboxesContainerClassName}>
        {checkBoxes.map((checkbox, index) => {
          type ValueKey = keyof typeof values;
          const myKey = name as ValueKey;
          const checked = Array.isArray(values[myKey])
            ? values[myKey].includes(checkbox.value)
            : values?.[myKey];

          return (
            <CustomCheckBox
              key={checkbox.id}
              {...checkbox}
              disabled={disabled ? true : checkbox.disabled}
              name={name}
              checkBoxClassName={checkBoxClassName}
              checked={checked}
              manualFieldsChangeOnOptionClick={handleManualFieldsChange}
            />
          );
        })}
      </div>
      {showError && (
        <h6 className="text-xs text-requiredRed mt-1">{errorString}</h6>
      )}
    </div>
  );
}

export default CustomCheckBoxInput;
